module.exports = __webpack_public_path__ + "static/media/h5-user-code.99618582.png";